/**
 * Число на значку: межа «99+» (UX-02, як «Задачі N»). Окремо від `live.ts`, бо його бере перший
 * екран (`shell/SideNav.tsx`, «Пошта N»), а живий стан сповіщень — лінивий чанк дзвіночка
 * (`notifications-live`, `vite.config.ts`): імпорт з `live.ts` тягнув би його в перший екран (#1244).
 */

/** Межа числа в дзвіночку й заголовку (UX-02, як «Задачі N»): далі — «99+». */
export const COUNT_CAP = 99;

export const countText = (n: number) => (n > COUNT_CAP ? `${COUNT_CAP}+` : String(n));
